<div class="login">
  <div class="panel">
    <p class="eyebrow">Acesso do administrador</p>
    <h1>Entrar no painel</h1>
    <p class="lede">Use o e-mail e senha do admin para buscar atletas cadastrados.</p>

    <form [formGroup]="form" (ngSubmit)="login()">
      <label>
        <span>Email</span>
        <input type="email" formControlName="email" placeholder="admin@bfc.com" />
        <small *ngIf="form.get('email')?.touched && form.get('email')?.invalid">
          Informe um email válido
        </small>
      </label>

      <label>
        <span>Senha</span>
        <div class="password">
          <input [type]="showPassword ? 'text' : 'password'" formControlName="password" placeholder="••••••••" />
          <button type="button" class="ghost" (click)="togglePassword()">
            {{ showPassword ? 'Ocultar' : 'Mostrar' }}
          </button>
        </div>
        <small *ngIf="form.get('password')?.touched && form.get('password')?.invalid">
          Informe sua senha
        </small>
      </label>

      <div class="error" *ngIf="errorMessage">{{ errorMessage }}</div>

      <button type="submit" [disabled]="loading">
        {{ loading ? 'Entrando...' : 'Entrar' }}
      </button>
      <p class="muted">Quer se cadastrar como atleta? <a routerLink="/">Voltar para o início</a></p>
    </form>
  </div>
</div>
